import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppWithSkeleton } from './components/AppWithSkeleton';
import { ErrorBoundary } from './components/ErrorBoundary';
import { OfflineSyncProvider } from './hooks/useOfflineSync';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <OfflineSyncProvider>
          <AppWithSkeleton>
            <App />
          </AppWithSkeleton>
        </OfflineSyncProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
